import { FC, useEffect, useState } from "react";
import clsx from "clsx";
import { Button } from "@ht/components";

import CallMissedIcon from "@ht/shared/fonts/deos-pis/call-missed";
import CallAnswerIcon from "@ht/shared/fonts/deos-pis/call";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";


import { ICallState, IIncomingMessage } from "../../../../app/call/types";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { callIncomingMessageReceived, callStateChanged, callSendMessage } from "../../../../app/call/callSlice";
import { setOverlay } from "../../../../app/layout/layoutStateSlice";
import { uid } from "@ht/shared/methods";
import { useDragging } from "../../../../hooks/useDragging";
import { setOnCall } from "../../../../app/userState/userStateSlice";
import ringtone from "../../../../../public/sound/ringtone.mp3";
import useSound from "use-sound";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../../../utils/encryption";
import { useHttpRequest } from "../../../../hooks/useHttpRequest";

declare global {
    interface Window {
        IVLConnect(a: string, b: string): void;
        setTURN(_customTURN:string,_customTURNUserName:string,_customTURNPassword:string):void;
        IVLDisconnect(): void;
        NotifyReactCallHangup(isClean: boolean): void;
        mute(): void;
    }
}
interface IProps {
    streamName: string;
    handleStreamName(name: string): void;
    handleChangeRoomStatus(status: string): void;
    meetingStatus: string;
    mediaServerUrl: string;
}
const MiniCallControl: FC<IProps> = ({ streamName, handleChangeRoomStatus, handleStreamName, meetingStatus, mediaServerUrl }) => {
    const dispatch = useAppDispatch();
    const wsdashurl = mediaServerUrl;
    const { incomingMessage, callState } = useAppSelector((state) => state.call);
    const { floatingLocation, overlay } = useAppSelector((state) => state.layoutstate);
    const { user } = useAppSelector((state) => state.auth);
    const callnotifWidth = 240;
    const locationX = floatingLocation.x === 0 ? (screen.width - callnotifWidth) / 2 : floatingLocation.x
    const locationY = floatingLocation.y === 0 ? floatingLocation.y + 66 : floatingLocation.y
    const { ref, x, y, isDragging, setPos } = useDragging(locationX, locationY, 240, 400);
    const [pickedUp, setPickedUp] = useState(false);
    const [ringing, setRinging] = useState(true);
    const [rejected] = useState(false);
    const [busyIntervalId, setBusyIntervalId] = useState(0);
    const [callConnected, setCallConnected] = useState(false);
    const [isMute] = useState(false);
    const [callDescription, setCallDescription] = useState("Incoming call from " + incomingMessage.username + "...");
    const [duration, setDuration] = useState(0);
    const [intervalId, setIntervalId] = useState(0);
    const [callId, setCallId] = useState("")
    const [, { stop }] = useSound(ringtone);
    const navigate = useNavigate()
    const { sendRequest } = useHttpRequest();
    const communicationServiceUrl = String(process.env.REACT_APP_CHAT_SERVICE);
    const [serviceGroupImageUrl, setServiceGroupImageUrl] = useState("")

    console.log("streamName", streamName);
    
    const setIncomingCall = (val: boolean) => {
        dispatch(callIncomingMessageReceived({} as IIncomingMessage));
    }
    let timer: number;
    const startTimer = () => {
        timer = window.setInterval(() => {
            setDuration(dur => dur + 1);
        }, 1000);
        setIntervalId(timer);

    };

    const stopTimer = () => {
        window.clearInterval(intervalId);
    }


    const answerCall = () => {
        if (!user)
            return;
        stop()
        handleStreamName(user?.username ?? "")
        setRinging(false);
        setPickedUp(true);
        setCallConnected(true);
        setCallDescription("Answered");
        window.clearInterval(busyIntervalId)
        startTimer();

        const cstate = { ...callState };
        cstate.duration = duration;
        cstate.isCalling = true;
        cstate.callConnected = callConnected;
        cstate.callDescription = callDescription;
        cstate.isMute = isMute;
        cstate.callType = "incoming";
        cstate.roomId = incomingMessage.username
        cstate.username = incomingMessage.username
        cstate.name = incomingMessage.username
        cstate.callDestination = incomingMessage.call_id
        cstate.sessionId = incomingMessage.session_id
        cstate.serviceGroupId = incomingMessage.service_group_id;
        cstate.serviceGroupImage = serviceGroupImageUrl;

        if ((incomingMessage.service_group_id ?? 0) == 0){
            setTimeout(() => {
                navigate(`/leads/${encrypt(incomingMessage.session_id)}`)
            }, 2000);
        }
            

        dispatch(callStateChanged(cstate));
        setPos({
            x: x - 260,
            y: y,
        })
        window.IVLConnect(wsdashurl, `IDLE_${user.deviceId}_${user.userId}_${incomingMessage.call_id}_${user.tenantId}`);
        handleChangeRoomStatus("meeting-audio-sip");
    }
    const resetIncomingCall = () => {
        dispatch(callIncomingMessageReceived({} as IIncomingMessage));
        dispatch(callStateChanged({} as ICallState));
    }

    const hangupCall = () => {
        stopTimer();
        setCallDescription("Call is over.");
        setCallConnected(false);
        window.IVLDisconnect();
        if (callState.callType === "incoming") {
            dispatch(setOnCall("ACW"));
        }
        else
            dispatch(setOnCall(""));
        handleChangeRoomStatus("close")
        if (callState.callType === "silent" || callState.callType === "coaching" || callState.callType === "bargein")
            dispatch(callSendMessage({ content: JSON.stringify({ type: "hangup", callType: callState.callType, callId: callState.callDestination }) }));
        resetIncomingCall();
    }

    const Busy = () => {
        stop()
        setRinging(false);
        setPickedUp(false);
        setCallDescription("Missed Call. You were busy.")
        if (callState.callType === "incoming") {
            dispatch(setOnCall("ACW"));
        }
        else
            dispatch(setOnCall(""));
        resetIncomingCall();
    }
    const closeModal = () => {
        if (!user)
            return;
        stop()
        setIncomingCall(false);
        handleChangeRoomStatus("close");

    }
    const loadServiceGroupData = async () => {
        const response = await sendRequest({
            baseUrl: communicationServiceUrl,
            url: `/service-group/getbyid/${incomingMessage.service_group_id}`,
            method: "get",
        });
        const data = response?.data as any;
        if (data) {
            setServiceGroupImageUrl(data.image);

        }


    }
    const BusyTimer = () => {
        let i = 0;
        let sentRinging = false;
        const tmr = window.setInterval(() => {
            if (callId !== "" && !sentRinging) {
                sentRinging = true
            }
            i++;
            if (i > 12) {
                if (!callConnected && !rejected) {
                    Busy();
                    handleChangeRoomStatus("missing-voice-sip")
                }
                window.clearInterval(tmr)
            }
        }, 1000);
        setBusyIntervalId(tmr)
    }
    useEffect(() => {
        if (meetingStatus === "waiting-voice-sip") {
            setPickedUp(false)
            setRinging(true);
            BusyTimer()
            setCallDescription("Incoming SIP call...")
        }
        return () => {
            window.clearInterval(busyIntervalId)
        }

    }, [meetingStatus])

    useEffect(() => {
        setCallId(uid(21))
        dispatch(setOnCall("Incoming Call"));
        loadServiceGroupData().catch(() => { })
        if(String(process.env.REACT_APP_CUSTOM_TURN)!="")
            window.setTURN(String(process.env.REACT_APP_CUSTOM_TURN),String(process.env.REACT_APP_CUSTOM_TURN_USERNAME),String(process.env.REACT_APP_CUSTOM_TURN_PASSWORD));
        
    }, [user])

    window.NotifyReactCallHangup = () => {
        let retryCount = 0
        window.NotifyReactCallHangup = (isClean: boolean) => {
            if (!user)
                return;
            console.log(new Date().toLocaleString(), "Hangup Triggered from IVL. DURATION:", duration, callState, "RETRY:", retryCount)
            if (duration < 1 && retryCount < 2 && !isClean && callState.callType == "incoming" && incomingMessage.call_id !== undefined) {
                console.log("receiving connection disconnected as soon as sending idle call, retrying...")
                window.IVLConnect(wsdashurl, `IDLE_${user.deviceId}_${user.userId}_${incomingMessage.call_id}_${user.tenantId}`);
                setDuration(0)
                retryCount++;
                console.log("retry count:", retryCount)
            } else {
                hangupCall();
            }

        }
    }
    useEffect(() => {
        if (incomingMessage.msg_type === "CANCELEDCALL" || incomingMessage.msg_type === "DISCONNECTEDCALL") {
            window.clearInterval(busyIntervalId)
            Busy()
            closeModal();
            handleChangeRoomStatus("")
        }

    }, [incomingMessage])
    const callButton = (
        <div className="flex flex-row justify-center h-[68px] w-[100%] gap-[36px]">

            <div className="flex flex-col items-center gap-[8px]">
                <Button shape="ellipse" onClick={() => answerCall()} type="button" variant="contained" color="primary" iconButton className="w-[44px] h-[44px]">
                    <CallAnswerIcon className="w-6 h-6 text-white" />

                </Button>
                <span className="text-black text-base font-semibold">Accept</span>
            </div>
        </div>
    )

    return (
        <>
            <div onClick={() => dispatch(setOverlay(false))} onKeyDown={() => { }} role="none" className={clsx("fixed z-[19] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                !overlay && "hidden"
            )}>
            </div>
            <div

                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    isDragging && "bg-geyser",
                    !isDragging && "bg-white",
                    "w-[234px] h-[358px] absolute shadow-sm rounded-lg bg-white z-[21] p-[8px] overflow-hidden"
                )}>

                <div className="flex flex-col justify-between items-center overflow-hidden h-[100%] w-[100%]">
                    <div ref={ref} className="draggable flex flex-col h-[100%] w-[100%]">
                        <div className="draggable flex flex-col w-[100%] items-center gap-[0px]">
                            <div className="flex flex-row justify-between w-[100%] ">
                                <div className="text-md self-end z-[1000] p-[2px] rounded-lg text-black"></div>
                                {!ringing &&
                                    <button tabIndex={-1} onKeyDown={closeModal}
                                        onClick={closeModal} className="text-md text-black self-end"><CloseIcon className="w-[16px] h-[16px]" width={24} height={24} />
                                    </button>
                                }

                            </div>

                            <div className="draggable flex flex-col py-[14px] gap-[32px] items-center">
                                <div className="flex flex-col items-center justify-between gap-[6px]">
                                    <div className="text-base font-semibold leading-4 text-gray-400">Audio Call</div>
                                    <div className="text-lg font-semibold leading-7 text-black">{incomingMessage?.username?.length > 20 ? incomingMessage?.username?.substring(0, 17) + "..." : incomingMessage?.username ?? ""}</div>
                                    <div className="text-base font-semibold leading-4 text-gray-400">{callDescription}</div>

                                </div>
                                {serviceGroupImageUrl &&
                                    <div className="mt-[8px] w-[89px] h-[89px] flex flex-row justify-center align-center">

                                        <img src={serviceGroupImageUrl} role="presentation"
                                            className="object-contain w-fit max-w-56 max-h-32 rounded-lg" alt="" />

                                    </div>
                                }
                                {!serviceGroupImageUrl &&
                                    <div className="w-[89px] h-[89px] rounded-full bg-geyser"></div>
                                }
                                <div className="h-[68px]">
                                    {(ringing || pickedUp) && callButton}
                                    {(!ringing && !pickedUp) &&
                                        // callButton
                                        (
                                            <div className="flex flex-col items-center h-[68px] w-[89px] center">
                                                <Button shape="ellipse" onClick={() => { }} type="button" variant="contained" color="danger" iconButton className="w-[44px] h-[44px]">
                                                    <CallMissedIcon className="w-[22px] h-[22px] mt-[2px] -ml-[2px] text-white" />
                                                </Button>
                                            </div>
                                        )
                                    }
                                </div>




                            </div>
                        </div>

                    </div>

                </div>
            </div>


        </>


    );
};

export default MiniCallControl;
